<template>
  <transition name="modal" >
      <div class="modal-mask">
      <div class="modal-wrapper" >  
        <div class="modal-container" @click.stop>
          <div class="modal-header">
            <slot name="header">
              {{this.header}}
            </slot>
          </div>
          <div class="modal-body">
            <slot v-if="!this.error" name="body">
              {{this.body}}
            </slot>
          </div>
          <el-form>
            <el-form-item >
              <el-input v-model="zipcode" label="zipcode" placeholder="Enter Zipcode..."></el-input>
              <button class="hidden-button" @click="enterZipcode($event)" ></button>
              <span class="error">{{this.error}}</span>
            </el-form-item>
            <el-form-item v-if="this.homeRadiusChecked">
              <button v-on:submit.prevent @click="closeModal($event)" class="modal-default-button">{{ $t('orderNow') }}</button>
            </el-form-item>
            <el-form-item v-else >
              <button @click="enterZipcode($event)" class="modal-default-button">{{ $t('checkZipcode') }}</button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    </transition>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'modal',
  props: ['header', 'body', 'footer'],
  data() {
    return {
      isVisible: true,
      header: '',
      zipcode: '',
      body: '',
      footer: '',
      isZipcodeFalse: false,
      error: '',
    }
  },
  methods: {
    ...mapMutations('navbar', ['validateRadiusHome', 'validateRadiusPurchase', 'toggleModal', 'resetHomeWithinRadius' ]),
    enterZipcode(e) {
      e.preventDefault();
      if (this.zipcode.length === 5) {
        this.error = '';
        this.$store.dispatch('navbar/validateDeliveryRadius', this.zipcode);
      } else {
        this.error = "Enter a valid zipcode.";
        this.body = '';
      }
      this.resetHomeWithinRadius();
    },
    closeModal(e) {
      e.preventDefault();
      this.toggleModal(false);
      // localStorage.setItem('showModalToken', false);
    },
  },
  watch: {
    header: function(newVal, oldVal) {
    },
    radiusCheckoutError: function(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        alert(newVal)
      }
    },
    radiusHomeError: function(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        this.body = newVal;
      }
    },
    homeWithinRadius: function(newVal, oldVal) {
      if (newVal === false) {
        this.body = "We are not in your area yet. But we are diligently expanding and look forward to servicing you soon."
        this.error = '';
      }
      if (newVal === true) {
        this.body = "We deliver to your area!";
        this.error = '';
      }
    },
    body: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.body = newVal;
      }
    },
    header: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.header = newVal;
      }
    },

  },
  computed: mapState({
    homeWithinRadius: state => state.navbar.homeWithinRadius,
    homeRadiusChecked: state => state.navbar.homeRadiusChecked,
    checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
    checkoutRadiusChecked: state => state.navbar.checkoutRadiusChecked,
    radiusCheckoutError: state => state.navbar.radiusCheckoutError,
    radiusHomeError: state => state.navbar.radiusHomeError,
    showModal: state => state.navbar.showModal,
  }), 
}
</script>


<style lang="less">
  @import "../assets/css/modal.less";
</style>



// WEBPACK FOOTER //
// src/view/modal.vue